export function getPaths(topLeftLonX, topLeftLatY, bottomRightLonX, bottomRightLatY) {
  var webApiUri = process.env.REACT_APP_WEB_API_URI;
  return fetch(`${webApiUri}/search/boundingBox?topLeftLonX=${topLeftLonX}&topLeftLatY=${topLeftLatY}&bottomRightLonX=${bottomRightLonX}&bottomRightLatY=${bottomRightLatY}`)
      .then(data => data.json())
  }